export enum PaginationArrowSize {
    Large = 'large',
    Medium = 'medium',
}
